import script from "./DeviceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceCard.vue?vue&type=script&setup=true&lang=js"

import "./DeviceCard.vue?vue&type=style&index=0&id=a180511e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a180511e"]])

export default __exports__